import api from '@/apis/bu/bUPlanImportAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Khoản
export const useBUPlanImportComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onBUPlanImportComboboxLoadData = (payload, row, column) => {
    payload.sort = 'ref_id';
    let extend = [{ Field: 'type_estimate', Value: 0 }];
    payload.columns += ',use_budget';
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const bUPlanImportComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã',
        dataField: 'ref_id',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên',
        dataField: 'plan_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'plan_name',
    valueField: 'ref_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onBUPlanImportComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    bUPlanImportComboConfig,
    onBUPlanImportComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
